<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="globe"/>
          {{ $t('title') }}
        </h1>
      </div>
    </div>
    <list></list>
  </main>
</template>

<script>
import List from './PlanOrderList';

export default {
  name: "PlanOrder",
  components: {List},
  i18n: {
    messages: {
      en: {
        title: 'Plan order',
      },
      vi: {
        title: 'Đơn hàng gói dịch vụ',
      }
    }
  }
}
</script>